import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CinfoPageRoutingModule } from './cinfo-routing.module';

import { CinfoPage } from './cinfo.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CinfoPageRoutingModule
  ],
  declarations: [CinfoPage]
})
export class CinfoPageModule {}
